module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_lilac_Front_10.b30304cd.png";